export default __webpack_public_path__ + "static/media/mongo.95ebe78c.png";